/**
 * SearchBar primitive — expandable search input with clear button.
 * Pure presentational component — zero hooks, zero API calls.
 * Uses Tailwind design tokens — no hardcoded hex colors.
 */
import React from 'react';
import { Search, X } from 'lucide-react';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onClear?: () => void;
}

export function SearchBar({ value, onChange, placeholder = 'Search all...', onClear }: SearchBarProps): React.ReactElement {
  return (
    <div className="relative mb-6">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
        <Search className="w-5 h-5 text-gray-400 dark:text-gray-300" />
      </div>
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search"
        className="w-full rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-surface-dark-card px-4 py-3 pl-12 pr-12 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 focus:border-disney-blue-500 focus:outline-none focus:ring-1 focus:ring-disney-blue-500"
      />
      {value && (
        <button
          type="button"
          onClick={onClear}
          aria-label="Clear search"
          className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <X className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
